import createIcon from "./createIcon";

export const ExcelIcon = createIcon('Excel', (props) => {
  return (
    <svg {...props} viewBox="0 0 16 16.1245">
      <rect width="16.000000" height="16.000000" x="0.000000" y="0.000000" />
      <g>
        <path d="M1.20703 0.124512L10.2066 0.124512L15.207 5.12444L15.207 15.1245C15.207 15.6768 14.7593 16.1245 14.207 16.1245L1.20703 16.1245C0.654746 16.1245 0.207031 15.6768 0.207031 15.1245L0.207031 1.12451C0.207031 0.572227 0.654746 0.124512 1.20703 0.124512Z" fill="rgb(29,184,123)" fillRule="evenodd" />
        <g>
          <path d="M6.04118 13.1245L4.20703 13.1245L6.63735 9.51019L4.36107 6.12451L6.27508 6.12451L7.13939 7.56331C7.33906 7.89356 7.52732 8.23306 7.78405 8.66955L7.8411 8.66955C8.05218 8.23306 8.22618 7.89356 8.41445 7.56331L9.23311 6.12451L11.0559 6.12451L8.77671 9.57717L11.207 13.1245L9.29016 13.1245L8.32032 11.5725C8.09782 11.2146 7.901 10.8451 7.64428 10.4201L7.59578 10.4201C7.37329 10.8451 7.17647 11.2146 6.96539 11.5725L6.04118 13.1245Z" fill="rgb(255,255,255)" fillRule="evenodd" />
        </g>
        <path d="M10.2071 4.12432L10.207 0.124268L15.2071 5.12427L11.2071 5.12431C10.6548 5.12431 10.2071 4.6766 10.2071 4.12432Z" fill="rgb(99,206,158)" fillRule="evenodd" />
      </g>
    </svg >
  )
});
